import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import ChatsList from '../../../Messages/ChatsList';
import Icon from '../../../Icon';
import styles from './index.styl';

export function PatientPortalCategory({
  handleSelectTab,
  dependentList,
  toggleDrawer,
  activeTab,
  tabs,
}) {
  const handleChooseTab = tab => {
    handleSelectTab(tab);
    toggleDrawer();
  };
  return (
    <div className={styles.root}>
      <div className={cn(styles.panel, styles.panelPrimary)}>
        <div className={styles.panelContainer}>
          <ChatsList
            minimized
            patientPortalContext
            patientPortalARList={dependentList}
          />
        </div>
      </div>
      <div className={cn(styles.panel, styles.panelSecondary)}>
        <div className={styles.panelContainer}>
          {tabs.length !== 0 && (
            <div className={styles.tabWrapper}>
              {tabs.map(({ id, tab, title }) => (
                <div
                  className={cn(styles.tab, {
                    [styles.tabActive]: tab === activeTab,
                  })}
                  key={id}
                  onClick={() => handleChooseTab(tab)}
                >
                  <Icon
                    size={24}
                    className={styles.tabIcon}
                    name={`icon-${tab}-white`}
                  />
                  {title}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

PatientPortalCategory.propTypes = {
  tabs: PropTypes.array,
  handleSelectTab: PropTypes.func,
  activeTab: PropTypes.string,
  toggleDrawer: PropTypes.func,
  dependentList: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Navigation/PatientPortalCategory/index.jsx